const ProfessionalDashboard = () => <h1>ProfessionalDashboard</h1>;

export default ProfessionalDashboard;
